import { handleDownloadTemplate } from './excel-template';

interface DownloadTemplateButtonProps {
  variant?: 'outline' | 'link';
  className?: string;
}

export function DownloadTemplateButton({ variant = 'outline', className = '' }: DownloadTemplateButtonProps) {
  if (variant === 'link') {
    return (
      <button
        type="button"
        onClick={handleDownloadTemplate}
        className={`text-xs font-medium text-brand-700 hover:underline flex items-center gap-1 ${className}`}
      >
        Need format help? Download Sample Template
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={handleDownloadTemplate}
      className={`inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-3.5 py-2 text-sm font-medium text-gray-700 shadow-sm transition-all hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2 ${className}`}
      title="Download Excel Template"
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
        <polyline points="7 10 12 15 17 10" />
        <line x1="12" y1="15" x2="12" y2="3" />
      </svg>
      Template
    </button>
  );
}
